<template>
  <div class="dropdownComp">

    <input
      class="input_grey"
      type="text"
      v-model="search"
      @keyup.enter="show = false"
      v-on:input="$emit('input', $event.target.value)"
      v-mask="mask"
    >
    <div v-show="showDropDown" class="dropdown">
      <ul>
        <li v-for="(item, index) in items" :key="index" @click="clickFind(item)">{{item}}</li>
      </ul>
    </div>

  </div>
</template>

<script>
import lodash from 'lodash'

export default {
  name: 'dropdownComp',
  props: {
    moduleName: {
      type: String,
      default: function () { return 'kontrollers' }
    },
    value: {
      type: String,
      default: function () { return null }
    },
    mask: { type: String, default: () => '' }
  },
  data: function () {
    return {
      show: false,
      search: null,
      count: 0
    }
  },
  created: function () {
    this.search = this.value
    this.$store.commit(`${this.moduleName}/setFinded`, this.value)

    this.debouncedGetAll = lodash.debounce(this.getAll, 500)
    var self = this
    document.addEventListener('click', function () { self.show = false })
  },
  mounted () {
    this.show = false
  },
  components: { },
  computed: {
    items: function () {
      return this.$store.getters[`${this.moduleName}/getFind`]
    },
    showDropDown: function () { return this.show }
  },
  watch: {
    search: function () {
      this.count++
      let active = false
      this.items.forEach(item => {
        if (item == this.search) {
          this.show = false
          active = true
        };
      })
      if (!active && this.count > 1) {
        this.debouncedGetAll()
        this.show = true
      };
    },
    value: function () {
      this.search = this.value
      this.$store.commit(`${this.moduleName}/setFinded`, this.value)
    }
  },
  methods: {
    getAll () {
      this.$store.dispatch(`${this.moduleName}/runFind`, { params: { limit: 5, search: this.search } })
    },
    clickFind (item) {
      this.search = item
      this.$store.commit(`${this.moduleName}/setFinded`, item)
      this.show = false
    }
  }
}
</script>

<style scoped lang="scss">

.dropdownComp {
  position: relative;
}
.dropdown {
  box-shadow: 0 0 10px rgba(0,0,0,0.5);
  z-index: 1001;
  background-color: #ffffff;
  position: absolute;
  width: 100%;
}
.dropdown ul {
  margin: 0;
  padding: 10px;
  text-align: left;
}
.dropdown ul li {
  list-style-type: none;
  padding: 2px;
}
.dropdown ul li:hover {
  background-color: #ff8200;
}

</style>
